<div class="flip-container" (click)="flip()" [class.flipped]="flipped">
  
  <div class="flipper">
    <!-- Front Card -->
    <ion-card class="service-card front" [ngClass]="{'ticket-top': flashcardData.haveTicket}" *ngIf="!flipped">
      <img class="card-image" src={{flashcardData.imgSrc}} alt="">
      <ion-card-content>
        <h2 class="secondary-text">{{ flashcardData.title }}</h2>
      </ion-card-content>
    </ion-card>
    <!-- Back Card -->
    <ion-card class="service-card back" [ngClass]="{'ticket-top': flashcardData.haveTicket}" *ngIf="flipped">
      <!-- titulo -->
      <ion-card-title>
        <h2 class="secondary-text">{{ flashcardData.title }}</h2>
      </ion-card-title>
      <!-- subtitulo -->
      <div class="card-content">
        <h4>{{ flashcardData.content }}</h4>
      </div>
      <!-- botones -->
      <div class="card-buttons-wrapper">
        <ion-button [fill]="button.fill" [color]="button.color" [size]="button.size" (click)="button.function()" *ngFor="let button of flashcardData.buttons">
          {{ button.text }}
          <ion-icon slot="start" [name]="button.icon" *ngIf="button.icon"></ion-icon>
        </ion-button>
      </div>
    </ion-card>
  </div>
</div>
<!-- Ticket -->
<ion-card button class="ticket-bottom" *ngIf="flashcardData.haveTicket">
  <ion-card-content>
    <ion-row>
      <ion-col class="ion-text-left">
        <h6 class="secondary-text">{{ flashcardData.ticketTitle }}</h6>
        <p class="cors-discount secondary-text"><u>{{ flashcardData.ticketSubtitle }}</u></p>
      </ion-col>
      <ion-col class="ion-text-center">
        <ion-button [fill]="button.fill" [color]="button.color" [size]="button.size" (click)="button.function()" *ngFor="let button of flashcardData.ticketButtons">
          {{ button.text }}
          <ion-icon slot="start" [name]="button.icon" *ngIf="button.icon"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-card-content>
</ion-card>